import { cva, type VariantProps } from "class-variance-authority";

export type DropdownMenuSize = "sm" | "md";

export const dropdownMenuItemVariants = cva(
  "relative flex cursor-pointer shrink-0 select-none items-center outline-none transition-colors data-[disabled]:hover:bg-transparent data-[disabled]:cursor-not-allowed data-[disabled]:text-black-400",
  {
    variants: {
      variant: {
        default: "text-black-950 hover:bg-black-100 focus:bg-black-100",
        danger: "text-red-500 hover:bg-red-50 focus:bg-red-50",
        blue: "text-blue-500 hover:bg-blue-50 focus:bg-blue-50",
      },
      size: {
        md: "rounded-xl min-h-10 py-2 px-2 gap-1.5 text-button-sm [&>svg:first-child]:size-6 last:mb-1.5",
        sm: "rounded-lg min-h-8 py-1.5 px-1.5 gap-1 text-button-xs [&>svg:first-child]:size-5 last:mb-1",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  },
);

export const dropdownMenuContentVariants = cva(
  "z-aboveDialog overflow-hidden bg-white shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
  {
    variants: {
      size: {
        md: "rounded-3xl",
        sm: "rounded-2xl",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);

export const dropdownMenuListVariants = cva(
  "flex flex-col min-h-0 overflow-x-hidden scrollbar-thin scrollbar-thumb-black-200",
  {
    variants: {
      size: {
        md: "mt-1.5 mr-1 pl-1.5 pr-1",
        sm: "mt-1 mr-0.5 pl-1 pr-0.5",
      },
      isHeightLimited: {
        true: "overflow-y-auto",
        false: null,
      },
    },
    defaultVariants: {
      size: "md",
      isHeightLimited: true,
    },
    compoundVariants: [
      {
        isHeightLimited: true,
        size: "md",
        class: "max-h-61.5",
      },
      {
        isHeightLimited: true,
        size: "sm",
        class: "max-h-49",
      },
    ],
  },
);

export type DropdownMenuItemVariant = NonNullable<
  VariantProps<typeof dropdownMenuItemVariants>["variant"]
>;

export const dropdownMenuLabelClassname =
  "px-2 pb-1.5 first:pt-1 pt-2.5 text-xs-medium text-black-500";
